import { browserHistory } from 'react-router'

import { connect } from 'react-redux'

import {
  getCountryTaxes,
} from 'reduxpath/ducks/CountryTax/List'

import {
  setCountryTax,
  setLoadState,
  setData,
} from 'reduxpath/ducks/CountryTax/Add'

import Add from './units'

const mapStateToProps = state => ({
  data: state.CountryTaxAdd.data,
  countrySelections: state.Reference.selectionsCountry,
  bankSelections: state.BankList.data.rows.map(bank => ({
    value: bank.id,
    label: bank.name,
  })),
})

const mapDispatchToProps = dispatch => ({
  handleFormChange(data) {
    return (e) => {
      const value = e.target.value
      const params = {
        data: {
          ...data,
          [e.target.name]: value,
        },
      }
      dispatch(setData(params))
    }
  },

  handleCountryChange(name, data) {
    return (selected) => {
      const params = {
        data: {
          ...data,
          [name]: selected.value,
        },
      }
      dispatch(setData(params))
    }
  },

  handleCancel() {
    browserHistory.push('/country_taxes')
  },

  addCountryTax(data) {
    return (e) => {
      e.preventDefault()

      dispatch(setLoadState(true))

      dispatch(setCountryTax(data, () => {
        dispatch(getCountryTaxes())
        dispatch(setLoadState(false))

        browserHistory.push('/country_taxes')
      }))
    }
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Add)
